"use client";

import { c as _c } from "react/compiler-runtime";
import { faArrowCircleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Link from "next/link";
import { Col, Row } from "react-bootstrap";
import { formatNameForUrl } from "@/components/nextGen/nextgen_helpers";
import styles from "@/components/nextGen/collections/NextGen.module.scss";
interface SlideshowHeaderProps {
  readonly collectionName: string;
}
export default function SlideshowHeader(t0) {
  const $ = _c(5);
  const {
    collectionName
  } = t0;
  let t1;
  if ($[0] !== collectionName) {
    t1 = formatNameForUrl(collectionName);
    $[0] = collectionName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `/nextgen/collection/${t1}/art`;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h5 className="mb-0 font-color d-flex align-items-center gap-2">View All<FontAwesomeIcon icon={faArrowCircleRight} className={styles.viewAllIcon} /></h5>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2) {
    t4 = <Row><Col className="d-flex align-items-center justify-content-end"><Link href={t2} className={`d-flex align-items-center gap-2 decoration-none ${styles.viewAllTokens}`}>{t3}</Link></Col></Row>;
    $[3] = t2;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}